/*
 * Invoerhulp voor het geboortedatumveld (FR-05).
 *
 * De bezoeker typt alleen cijfers; de streepjes komen er vanzelf tussen. Dat
 * scheelt de doelgroep uit NFR-01 werk, en op mobiel is het zelfs noodzakelijk:
 * het veld staat op `inputmode="numeric"`, dus daar zit geen streepje op het
 * toetsenbord.
 *
 * Twee keuzes die het verschil maken tussen een prettige en een vervelende mask:
 *
 * 1. Een streepje verschijnt pas zodra er een cijfer achter staat. Zou het veld
 *    na twee cijfers meteen "03-" tonen, dan wist backspace dat streepje en zet
 *    de mask het er direct weer neer — de invoer vecht dan terug.
 * 2. De cursor blijft achter hetzelfde cijfer staan. Zonder dat springt hij naar
 *    het eind zodra iemand midden in het veld een typefout herstelt.
 *
 * Er wordt hier bewust niets afgekeurd. Of 35-19-52 een bestaande datum is, is
 * een vraag voor de validatie (WP-10) en voor de server (WP-11); tijdens het
 * typen iets weigeren maakt een veld alleen maar onvoorspelbaar.
 */

/** Maakt van de losse cijfers in `ruw` de vorm dd-mm-jjjj. */
export function formatteerDatum(ruw: string): string {
  const cijfers = ruw.replace(/\D/g, '').slice(0, 8)

  return [cijfers.slice(0, 2), cijfers.slice(2, 4), cijfers.slice(4, 8)]
    .filter(Boolean)
    .join('-')
}

/**
 * De cursorpositie in `geformatteerd` die achter `cijfersVoorCaret` cijfers ligt.
 */
export function caretNaFormatteren(
  geformatteerd: string,
  cijfersVoorCaret: number,
): number {
  let positie = 0
  let geteld = 0

  while (positie < geformatteerd.length && geteld < cijfersVoorCaret) {
    if (/\d/.test(geformatteerd.charAt(positie))) geteld++
    positie++
  }

  return positie
}
